const rate = {
  path: 'rate',
  component: resolve => require(['../../../../../../pages/admin/reviewed/wechat/rate'], resolve),
  meta: {isRate: true}
}

export default rate
